module.exports = __webpack_public_path__ + "img/icons8-ford.75149206.svg";